import validator from 'is_js';
import { Messages } from './constants';

const checkEmpty = (val, key) => {
    if (validator.empty(val.trim())) {
        return `${key}`;
    } else {
        return '';
    }
};

export default function (data) {
    const {
        typeValue,
        descValue,
    } = data;

    if (typeValue !== undefined) {
        let emptyValidationText = checkEmpty(typeValue, Messages.validation.isEmpty)
        if (emptyValidationText !== '') {
            return emptyValidationText;
        }
    }
    if (descValue !== undefined) {
        let emptyValidationText = checkEmpty(descValue, Messages.validation.isEmpty)
        if (emptyValidationText !== '') {
            return emptyValidationText;
        }
    }
} 